export interface SsoStatus {
  status: number;
  emailDomain: string | null;
  idpProviderHint: string | null;
}

export interface SsoDomainVerification {
  emailDomain: string;
  recordName: string;
  recordValue: string;
  verifiedAt: string | null;
}

export interface SsoMetadata {
  spEntityId: string;
  spAcsUrl: string;
}

export interface ScimStatus {
  status: number;
  idpProviderHint: string | null;
  scimEndpoint: string | null;
}

export const providerOptions = [
  "GenericSaml",
  "EntraId",
  "GoogleWorkspace",
  "Okta",
] as const;

export const providerLabels: Record<string, string> = {
  GenericSaml: "Generic SAML",
  EntraId: "Entra ID",
  GoogleWorkspace: "Google Workspace",
  Okta: "Okta",
};

export function supportsScim(idpProviderHint: string | null) {
  return idpProviderHint !== "GoogleWorkspace";
}
